
import React, { useEffect, useState } from "react";
import {Copy, Check, X } from "lucide-react";
import Header from "../Components/Header";
import AnimatedMenu from "../Components/AnimatedMenu";

const LoaderShowcase = () => {
  const [loaders, setLoaders] = useState([]);
  const [filteredLoaders, setFilteredLoaders] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("spinner");
  const [copiedStates, setCopiedStates] = useState({});
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  // Fetch loaders from JSON file
  useEffect(() => {
    const fetchLoaders = async () => {
      try {
        const response = await fetch("loaders.json");
        const data = await response.json();
        setLoaders(data.loaders);
        setTotalCount(data.loaders.length);
        filterData(data.loaders, "spinner");
      } catch (error) {
        console.error("Error fetching loaders:", error);
      }
    };

    fetchLoaders();
  }, []);

  const filterData = (data, category) => {
    setFilteredLoaders(
      data.filter((loader) =>
        loader.category.toLowerCase() === category.toLowerCase()
      )
    );
  };

  const handleCategoryChange = (category) => {
    if (isMenuOpen)
    {
      setIsMenuOpen(false)
    }
    setSelectedCategory(category);
    filterData(loaders, category);
  };

  const createStyleElement = (css, loaderId, type) => {
    const styleId = `${type}-style-${loaderId}`;
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      const regex = new RegExp(`\\.${type}`, "g");
      style.textContent = css.replace(regex, `.${type}-${loaderId}`);
      document.head.appendChild(style);
    }
  };

  const renderLoader = (loader, index) => {
    const match = loader.htmlTag.match(/class='(.*?)'/);
    const type = match[1];
    createStyleElement(loader.css, index, type);
    const safeHtml = loader.htmlTag.replace(
      `class='${type}'`,
      `class='${type}-${index}'`
    );
    return <div dangerouslySetInnerHTML={{ __html: safeHtml }} />;
  };

  const copyToClipboard = async (text, loaderId) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedStates({ ...copiedStates, [loaderId]: true });
      setTimeout(() => {
        setCopiedStates({ ...copiedStates, [loaderId]: false });
      }, 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const formatCSS = (css) => {
    // CSS formatting logic...
    return css.trim();
  };

  const getCombinedCode = (loader) => {
    return `${loader.htmlTag}\n\n/* CSS */\n${formatCSS(loader.css)}`;
  };

  return (
    <div
    className={`min-h-screen flex ${
      isDarkMode ? "bg-gray-800 text-white" : "bg-gray-100 text-gray-900"
    }`}
    >
      
    
       {/* Left Sidebar: AnimatedMenu */}
      <div className="w-full md:w-1/4 lg:w-1/5 bg-gray-50 dark:bg-gray-900 p-1 sticky top-0 h-screen hidden lg:block" >
  <AnimatedMenu
    getLoaderLength={(category) =>
      loaders.filter(
        (loader) =>
          loader.category.toLowerCase() === category.toLowerCase()
      ).length
    }
    onCategoryChange={handleCategoryChange}
    activeCategory={selectedCategory}
    isDarkMode={isDarkMode}
  />
</div>

{
        isMenuOpen && <div className="relative bg-gray-50 dark:bg-gray-900 p-4 sticky top-0 h-screen z-50 m-2">
         <X className="block lg:hidden absolute top-0 right-0" onClick={() => setIsMenuOpen(false)} />
            
          <AnimatedMenu
            getLoaderLength={(category) =>
              loaders.filter(
                (loader) =>
                  loader.category.toLowerCase() === category.toLowerCase()
              ).length
            }
            onCategoryChange={handleCategoryChange}
            activeCategory={selectedCategory}
            isDarkMode={isDarkMode}
            setIsMenuOpen={setIsMenuOpen}
          />
        </div>
        
        }
    {/* Main Content: Loaders Grid */}
    <div className="flex-grow">
        {/* Header */}     
       
      <Header
        isDarkMode={isDarkMode}
        onThemeToggle={() => setIsDarkMode(!isDarkMode)}
          totalCount={totalCount}
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
      />
  
        {/* Search and Filter */}
        
      <div className="container mx-auto py-4">
        {/* Loaders Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredLoaders.map((loader, index) => (
            <div
              key={loader.ID}
              className={`rounded-lg shadow overflow-hidden hover:shadow-lg transition-shadow duration-300 relative group ${
                isDarkMode ? "bg-gray-800" : "bg-white"
              }`}
            >
              <div
                className={`border-b p-4 ${
                  isDarkMode
                    ? "bg-gray-700 border-gray-600"
                    : "bg-gray-50 border-gray-200"
                }`}
              >
                <div className="text-lg flex justify-between items-center">
                  {loader.name}
                  <span
                    className={`text-sm px-3 py-1 rounded-full ${
                      isDarkMode
                        ? "bg-purple-900/50 text-purple-300"
                        : "bg-purple-100 text-purple-700"
                    }`}
                  >
                    {loader.category} - #{loader.ID}
                  </span>
                </div>
              </div>
              <div
                className={`p-8 flex items-center justify-center min-h-40 relative group ${
                  loader.isWhite === "TRUE" ? "bg-gray-300" : "bg-gray-900"
                }`}
              >
                {renderLoader(loader, loader.ID)}
                <button
                  onClick={() =>
                    copyToClipboard(getCombinedCode(loader), index)
                  }
                  className="absolute top-2 right-2 bg-white rounded-full p-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-gray-100"
                  title="Copy all code"
                >
                  {copiedStates[index] ? (
                    <Check size={16} className="text-green-600" />
                  ) : (
                    <Copy size={16} className="text-gray-600" />
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
  
  );
};

export default LoaderShowcase;
